import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tiempo: [],
  },

  getters: {
    getTiempo: (state) => state.tiempo,
  },

  mutations: {
    SET_TIEMPO(state, tiempo) {
      state.tiempo = tiempo;
    },
  },

  actions: {
    async fetchTiempo({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catTiempo')
        .then((response) => {
          commit('SET_TIEMPO', response.data.data);
        });
    },
  },
};
